import React from 'react';
import cls from 'classnames';
import PropTypes from 'prop-types';
import MessageContainer from '@/components/message/items/message-container';
import MessageAvatar from '@/components/message/items/message-avatar';
import { SEND_MESSAGE, bus } from '@/event/message_events';

import audioStyles from './audio-message.module.scss';

const NormalMessage = (props) => {
  const {
    avatar,
    senderOid,
    senderType,
    fromMe,
    avatarClassName,
    children,
    error,
    msgContent,
    isImgMessage,
  } = props;

  const sendMsg = () => {
    bus.emit(SEND_MESSAGE, msgContent);
  };

  return (
    <MessageContainer fromMe={fromMe}>
      <MessageAvatar
        className={avatarClassName}
        fromMe={fromMe}
        avatar={avatar}
        senderOid={senderOid}
        senderType={senderType}
      />
      <div className={cls(fromMe ? 'ms-content right' : 'ms-content left', { 'img-message': isImgMessage })}>
        {children}
      </div>
      {error && (
        <a className={audioStyles.retry} onClick={sendMsg}>
          重发
        </a>
      )}
    </MessageContainer>
  );
};

NormalMessage.propTypes = {
  avatar: PropTypes.string,
  avatarClassName: PropTypes.string,
  senderType: PropTypes.string,
  senderOid: PropTypes.string,
  fromMe: PropTypes.bool,
  children: PropTypes.any,
  error: PropTypes.bool,
  isImgMessage: PropTypes.bool,
  msgContent: PropTypes.object,
};

export default NormalMessage;
